import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "report",
  "use": "report-usage",
  "viewBox": "0 0 14.9 15.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.9 15.5\" id=\"report\"><path d=\"M11 14H1.5V1.5H11v1.75l1.5-1.5V0H0v15.5h12.5V8.45L11 9.95V14z\" /><path d=\"M7.24 12.57l-2.3-2.3-.19.18v2.3h2.3l.19-.18zM5.346 9.869L12.602 2.6l2.3 2.296-7.256 7.269zM2.75 3.08h7.08v1.5H2.75zM2.75 6.42h4v1.5h-4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id